module.exports = __webpack_public_path__ + "static/media/non-diver-btn-tc.51ef6840.png";